(function () {
  'use strict';

  var M = null;
  var rootEl = null;

  function S() { return M.state; }
  function money(n) { return M.money(n); }

  var arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function locList() {
    return M.orders.location.map(function (id) { return { id: id, label: M.LABELS.location[id].label }; });
  }
  function bdList() {
    var s = S();
    return M.orders.backdrop
      .filter(function (id) { return M.isAvail(s.location, id); })
      .map(function (id) { return { id: id, label: M.LABELS.backdrop[id].label }; });
  }
  function ltList() {
    return M.orders.lighting.map(function (id) { return { id: id, label: M.LABELS.lighting[id].label }; });
  }
  function imgList() {
    return M.imageOrder().map(function (id) { return { id: id, label: M.LABELS.images[id].label }; });
  }

  function thumb() {
    return '<div class="cb__thumb" data-cb-thumb>' +
      '<img class="cb__thumb-img" data-cb-media alt="" hidden>' +
      '<img class="cb__thumb-cut" data-cb-cut alt="" hidden>' +
    '</div>';
  }
  function updateThumb(s) {
    var box = rootEl.querySelector('[data-cb-thumb]');
    if (!box) return;
    var img = rootEl.querySelector('[data-cb-media]');
    var cut = rootEl.querySelector('[data-cb-cut]');
    var v = M.resolveVariant(s);
    var src = (v && v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
    var bs = window.backdropSelector;
    var isGrad = M.LABELS.lighting[s.lighting].ltKey === 'Gradient Lighting';
    if (M.isColour(s.backdrop) && s.colourLocked && s.colour) {
      box.style.backgroundColor = M.findCat(s.colour).hex;
      box.classList.toggle('cb__thumb--gradient', isGrad);
      var lockCut = (bs && bs.lightingImage) ? bs.lightingImage(M.LABELS.lighting[s.lighting].ltKey) : '';
      if (cut) { if (lockCut && cut.getAttribute('src') !== lockCut) cut.src = lockCut; cut.hidden = !lockCut; }
      if (img) { img.hidden = true; img.removeAttribute('src'); }
    } else if (src) {
      box.style.backgroundColor = '';
      box.classList.remove('cb__thumb--gradient');
      if (cut) { cut.hidden = true; cut.removeAttribute('src'); }
      if (img) { if (img.getAttribute('src') !== src) img.src = src; img.hidden = false; }
    } else if (M.isColour(s.backdrop)) {
      box.style.backgroundColor = '#cfd2d4';
      box.classList.toggle('cb__thumb--gradient', isGrad);
      var nCut = (bs && bs.lightingImage) ? bs.lightingImage(M.LABELS.lighting[s.lighting].ltKey) : '';
      if (cut) { if (nCut && cut.getAttribute('src') !== nCut) cut.src = nCut; cut.hidden = !nCut; }
      if (img) { img.hidden = true; img.removeAttribute('src'); }
    } else {
      box.style.backgroundColor = '';
      box.classList.remove('cb__thumb--gradient');
      if (cut) { cut.hidden = true; cut.removeAttribute('src'); }
      if (img) { img.hidden = true; img.removeAttribute('src'); }
    }
  }

  function sel(k, label, list, cur) {
    var opts = list.map(function (o) {
      return '<option value="' + o.id + '"' + (String(o.id) === String(cur) ? ' selected' : '') + '>' + o.label + '</option>';
    }).join('');
    return '<label class="cb__sel"><span>' + label + '</span><select data-cb="' + k + '">' + opts + '</select></label>';
  }

  function selectors() {
    var s = S();
    return '<div class="cb__sels" data-cb-sels>' +
      sel('location', 'Location', locList(), s.location) +
      sel('backdrop', 'Backdrop', bdList(), s.backdrop) +
      '<span data-cb-ltwrap' + (M.isColour(s.backdrop) ? '' : ' hidden') + '>' +
        sel('lighting', 'Lighting', ltList(), s.lighting) +
      '</span>' +
      sel('images', 'Edited images', imgList(), s.images) +
      '<label class="cb__sel cb__sel--n"><span>People</span>' +
        '<input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="3" value="' + s.people +
        '" data-cb-people aria-label="Number of people"></label>' +
    '</div>';
  }

  function priceBlock() {
    var c = M.calc(S());
    var s = S();
    return '<div class="cb__price">' +
      '<span class="cb__price__main"><em data-product-discounted-price data-cbb="pp">' + money(c.ppAfter) + '</em><u>/ person</u></span>' +
      '<span class="cb__price__sub" data-cbb="sub">' +
        (c.pct ? '<b class="bh-red">−' + c.pct + '%</b> · ' + s.people + ' people' : 'one person') +
      '</span>' +
    '</div>';
  }

  function buyBtn() {
    return '<button type="button" class="cb__buy" data-cb-buy>Add to cart <i>' + arrow + '</i></button>';
  }
  function packagesBtn() {
    return '<button type="button" class="cb__packages" data-cb-top>View Packages</button>';
  }

  function bar() {
    return '<div class="cb" data-cb-bar data-screen-label="Sticky cart bar">' +
      '<div class="cb__inner">' + thumb() + selectors() + packagesBtn() + priceBlock() + buyBtn() + '</div>' +
    '</div>';
  }

  function updateBar() {
    if (!rootEl) return;
    var s = S();
    var c = M.calc(s);
    rootEl.querySelectorAll('[data-cbb="pp"]').forEach(function (el) { el.textContent = money(c.ppAfter); });
    rootEl.querySelectorAll('[data-cbb="sub"]').forEach(function (el) {
      el.innerHTML = c.pct
        ? '<b class="bh-red">−' + c.pct + '%</b> · ' + s.people + ' people'
        : 'one person';
    });
    rootEl.querySelectorAll('select[data-cb]').forEach(function (el) {
      var k = el.getAttribute('data-cb');
      if (k === 'backdrop') {
        var avail = bdList();
        if (el.options.length !== avail.length) {
          el.innerHTML = avail.map(function (b) {
            return '<option value="' + b.id + '"' + (b.id === s.backdrop ? ' selected' : '') + '>' + b.label + '</option>';
          }).join('');
          return;
        }
      }
      if (String(el.value) !== String(s[k])) el.value = String(s[k]);
    });
    rootEl.querySelectorAll('[data-cb-ltwrap]').forEach(function (lt) { lt.hidden = !M.isColour(s.backdrop); });
    rootEl.querySelectorAll('[data-cb-people]').forEach(function (ppl) {
      if (document.activeElement !== ppl) ppl.value = s.people;
    });
    updateThumb(s);
  }

  function onScroll() {
    if (!rootEl) return;
    var barEl = rootEl.querySelector('[data-cb-bar]');
    var inst = document.getElementById('bkInstrument');
    if (!barEl || !inst) return;
    var cta = document.querySelector('.bkp-cta');
    var atCtaOrBelow = cta ? (cta.getBoundingClientRect().top < window.innerHeight) : false;
    var on = inst.getBoundingClientRect().bottom < 120 && !atCtaOrBelow;
    barEl.classList.toggle('is-on', on);
    if (on) document.body.style.setProperty('--cb-h', barEl.offsetHeight + 'px');
    document.body.classList.toggle('cb-is-on', on);
  }

  function scrollToTop() {
    var target = document.querySelector('.bkp-h1')
      || document.getElementById('bkInstrument')
      || document.querySelector('.bp-booking-body');
    if (!target) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
    catch (e) { target.scrollIntoView(); }
  }

  function onClick(e) {
    if (e.target.closest('[data-cb-buy]')) { M.requestAdd(); return; }
    if (e.target.closest('[data-cb-top]')) { scrollToTop(); return; }
  }
  function onChange(e) {
    var t = e.target.closest('select[data-cb]');
    if (t) { M.setOption(t.getAttribute('data-cb'), t.value); return; }
    var p = e.target.closest('[data-cb-people]');
    if (p) {
      var v = parseInt(p.value.replace(/\D/g, ''), 10);
      M.setPeople(isNaN(v) ? 1 : v);
    }
  }
  function onInput(e) {
    var p = e.target.closest('[data-cb-people]');
    if (!p) return;
    var clean = p.value.replace(/\D/g, '');
    if (clean !== p.value) p.value = clean;
    var v = parseInt(clean, 10);
    if (isNaN(v)) return;
    M.setPeople(v);
    p.focus();
  }
  function render() {
    rootEl.innerHTML = bar();
    onScroll();
  }
  function mount(el) {
    if (!window.BK_MACHINE) { return window.setTimeout(function () { mount(el); }, 30); }
    M = window.BK_MACHINE;
    rootEl = el;
    if (el.parentNode !== document.body) document.body.appendChild(el);
    document.body.classList.add('has-cartbar');
    render();
    el.addEventListener('click', onClick);
    el.addEventListener('change', onChange);
    el.addEventListener('input', onInput);
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('bk:state', updateBar);
    updateBar();
  }

  window.BK_CARTBAR = { mount: mount };
})();
